export const closeReasons = [
  {
    value: 'position_filled_through_offerzen',
    label: 'Position filled through OfferZen',
  },
  {
    value: 'position_filled_through_another_source',
    label: 'Position filled through another source',
  },
  {
    value: 'not_enough_candidates',
    label: 'Not enough candidates',
  },
  {
    value: 'no_longer_hiring_for_position',
    label: 'No longer hiring for this position',
  },
  {
    value: 'on_hold_or_hiring_freeze',
    label: 'On hold or hiring freeze',
  },
  {
    value: 'other',
    label: 'Other',
  },
]

export const formatCloseReason = (closeReason, closeReasonOtherDescription) => {
  const closeReasonEntry = closeReasons.find(reason => reason.value === closeReason)

  if (!closeReasonEntry) return

  return closeReasonOtherDescription ? `${closeReasonEntry.label}: ${closeReasonOtherDescription}` : closeReasonEntry.label
}
